/**
*   Too find out if ng-content has projected content in it, we need to check if there are any children in it
*
*   Returns true if there are any children that are not comment nodes
*
*   Example:
*
*   <div #aggregate">
*       <ng-content></ng-content>
*   </div>
*
*   ngAfterContentInit() {
*       this.hasAggregateContent = helpers.hasContentProjection(this.aggregate.nativeElement);
*   }
*/
export const hasContentProjection = (element: HTMLElement) =>  {
    if (!element)  {
        return false;
    }

    let hasContent: boolean = false;
    const nodes: NodeList = element.childNodes;
    for (let x = 0; x < nodes.length; x++) {
      if (nodes.item(x).nodeType !== 8) {
        hasContent = true; // nodeType == 8 means is a comment
        break;
      }
    }

    return hasContent;
};
